import { useMemo } from 'react';
import { useT } from '../../translation/src';

export const useSubscriptionTypeTranslations = () => {
  const FLEX = useT('flex', { swc: true });
  const LAUNCH = useT('launch', { swc: true });
  const GROW = useT('grow', { swc: true });
  const SCALE = useT('scale', { swc: true });
  const CUSTOM = useT('custom', { swc: true });

  const translations = useMemo(() => {
    return { FLEX, LAUNCH, GROW, SCALE, CUSTOM };
  }, [FLEX, LAUNCH, GROW, SCALE, CUSTOM]);

  return translations;
};
